import * as React from 'react';
import { Modal } from 'antd';
import { ModalProps } from 'antd/lib/Modal';
import { default as styled } from 'styled-components';

import {
  blueColor,
  lightBlackColor,
  orangeColor,
  transparentColor,
  weightBlackColor,
  whiteColor,
  whiteGreyLinearColor,
  titleColor,
  contentFontColor,
  borderColor
} from '@config/index';

const StyledModal: typeof Modal = styled(Modal)`
  padding-bottom:0 !important;

  .ant-modal-header {
    padding-top: 21px;
    padding-bottom: 21px;
    border-bottom: 1px solid ${borderColor};

    .ant-modal-title {
      color: ${contentFontColor};
      font-size: 1.17em;
      font-weight: 500;
    }

    .ant-btn-primary {
      margin-left: 24px;
    }
  }

  .ant-modal-body {
    padding: 24px 36px;

    >.ni-form>.ni-form-item {
      margin-bottom: 24px;
    }
  }

  .ant-modal-footer {
    padding-top: 12px;
    padding-bottom: 12px;
    border-top: 1px solid ${borderColor};

    .ant-btn {
      background: inherit;
      color: ${contentFontColor};
    }

    .no-border {
      border:none;
    }

    .ant-btn-primary {
      margin-left: 8px;
      background: ${blueColor};
      color: white;
    }

    .ant-btn-ghost {
      border: 1px solid ${lightBlackColor};
      cursor: not-allowed;
      background: rgba(0,0,0,0.12);
      color: #ffffff;

      &:hover {
        border: 1px solid ${lightBlackColor};
        background: rgba(0,0,0,0.12);
        color: #ffffff;
      }
    }
  }

  .ant-btn {
    border: 1px solid ${lightBlackColor};
    border-radius: 6px;
    height: 32px;
    background: ${whiteGreyLinearColor};
    color: ${weightBlackColor};
    font-size: 14px;
    font-weight: normal;
    line-height: 21px;
    &:hover {
      border: 1px solid ${lightBlackColor};
      background: ${whiteGreyLinearColor};
      color: ${weightBlackColor};
    }

    &.ant-btn-primary {
      border: 0;
      background: ${blueColor};
      color: ${whiteColor};
    }

    &.ant-btn-danger {
      border: 1px solid ${orangeColor};
      background: ${transparentColor};
      color: ${orangeColor};
    }
  }
` as any;

export class NiModal extends React.Component<ModalProps> {

  render() {
    const props: ModalProps = {
      width: '60%',
      centered: true,
      closable: false,
      ...this.props,
      className: 'ni-modal ' + this.props.className
    };

    return (
      <StyledModal
        {...props}
      />
    );
  }
}
